import Vue from "vue";
import VeeValidate from "vee-validate";
import i18n from "./i18n";

import de from "vee-validate/dist/locale/de";
import en from "vee-validate/dist/locale/en";
import it from "vee-validate/dist/locale/it";

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    en: {
      messages: en.messages
    },
    de: {
      messages: de.messages,
      attributes: { "components.0.extract_entries.0.area": "test" } //TODO: implement attributes
    },
    it: {
      messages: it.messages
    }
  }
});
